import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { formEditable, TFormEditableCodec } from "../../../shared/src/codecs/types/formEditable";
import { AdminUser, TAdminUserCodec } from "../User";

export const AdminUserEditable: TFormEditableCodec<TAdminUserCodec> = formEditable(AdminUser);
export type TAdminUserEditableCodec = typeof AdminUserEditable;
export type TAdminUserEditable = TTypeOfCodec<TAdminUserEditableCodec>;